import Settings from 'configs/Settings';

import Request from '@hotmart/request';

Request.register(`${Settings.api.clubUser}/v4`, {
  get: {
    'get.user': '/userArea/:userId',
    'get.user_history': '/history/:userId',
    'get.lessons': '/userArea/:userId/lessons',
    'get.config': '/config'
  },
  post: {
    'post.search_user': '/search?page=:page&size=:size&sort=:sort',
    'post.export_csv':
      '/search/generateDownloadLink?sort=:sort&columns=:columns',
    'user.resend_access': '/users/:userId/resendAccess',
    'user.change_class': '/bulkActions/changeClass',
    'post.change_status': '/bulkActions/changeStatus',
    'post.resend_access': '/bulkActions/resendAccess'
  },
  put: {
    'user.change_status': '/userArea/:userId/changeStatus',
    'user.change_role': '/userArea/:userAreaId/changeRole',
    'user.update_purchase_date': '/userArea/:userAreaId/changePurchaseDate'
  },
  delete: {
    'user.delete': '/userArea/:userId'
  }
});

Request.register(`${Settings.api.content}/v4`, {
  get: {
    'get.modules_tree': '/modules/tree',
    'get.quizzes_exercise': '/quizzes/exercise',
    'get.quizzes_profile': '/quizzes/profile',
    'get.quiz_profiles': '/quizzes/:quizId/profiles'
  }
});
